import {
  ASSET_LIST,
  ASSET_REGISTER_REPORT,
  ASSIGNMENT_HISTORY_REPORT,
  BRAND_LIST,
  CATEGORY_LIST,
  COST_SUMMARY_REPORT,
  DEPARTMENT_LIST,
  DEPARTMENT_WISE_REPORT,
  DESIGNATION_LIST,
  EMPLOYEE_LIST,
  INVENTORY_ITEM_LIST,
  LICENSE_EXPIRY_LIST,
  LOCATION_LIST,
  LOCATION_WISE_REPORT,
  LOW_STOCK_LIST,
  MODEL_LIST,
  REPAIR_HISTORY_REPORT,
  VENDOR_LIST,
  WARRANTY_EXPIRY_LIST,
} from '@constants/internal-route.constant'

// The feature urls under each sidebar group. A group renders only when the user holds at least one
// of them (SidebarMenuItemWithSub `anyOf`), so a role granted nothing in a group never sees an
// empty accordion. The groups do not follow the url prefixes: Assets (/asset) and Inventory Items
// (/inventory-item) sit in Master Data, the three expiry/stock alert lists in Reports, so a group is
// active by these urls (whole-segment matching, so an asset's detail page lights Master Data too).

export const REPORTS_ROUTES = [
  ASSET_REGISTER_REPORT,
  ASSIGNMENT_HISTORY_REPORT,
  REPAIR_HISTORY_REPORT,
  DEPARTMENT_WISE_REPORT,
  LOCATION_WISE_REPORT,
  COST_SUMMARY_REPORT,
  WARRANTY_EXPIRY_LIST,
  LICENSE_EXPIRY_LIST,
  LOW_STOCK_LIST,
]

export const MASTERDATA_ROUTES = [
  ASSET_LIST,
  INVENTORY_ITEM_LIST,
  CATEGORY_LIST,
  BRAND_LIST,
  MODEL_LIST,
  VENDOR_LIST,
  LOCATION_LIST,
  DEPARTMENT_LIST,
  DESIGNATION_LIST,
  EMPLOYEE_LIST,
]
